export default __webpack_public_path__ + "static/media/bacqueville13.db77445b.jpg";